// extracted by mini-css-extract-plugin
export default {"copyright":"Footer_copyright__Yoh4-","left":"Footer_left__JQ1mJ","right":"Footer_right__vA9bE","row":"Footer_row__-1bMG"};